import {useAlternateLocales, useIsProxied} from '@aboutyou/config';
import {
  TADARIDA_SESSION_PERSIST_KEY,
  USER_DATA_EXCLUDED_FROM_PERSISTING,
  USER_PERSIST_KEY,
  USER_PERSIST_OPTIONAL_KEY,
  useBasketCount,
  useOptionalUser,
  useSessionId,
  useUser,
  useWishlistCount,
} from '@aboutyou/user';
import React from 'react';
import {useIsAuthenticated} from '../../features/Authentication/hooks/useIsAuthenticated';
import {ShareUserSession} from './ShareUserSession';

const SessionSharing = () => {
  const {data: sessionState} = useSessionId();
  const {data: tadaridaUser} = useUser();
  const {data: tadaridaOptionalUser} = useOptionalUser();
  const alternateLangUrl = useAlternateLocales();

  const isProxiedMobileDomain = useIsProxied();

  const basketCount = useBasketCount();
  const {count: wishlistCount} = useWishlistCount();
  const {isAuthenticated} = useIsAuthenticated();

  // disable session sharing with consent is not given
  if (!sessionState?.sessionId || !tadaridaUser || !alternateLangUrl) {
    return null;
  }

  const mandatoryFieldsValues = Object.fromEntries(
    Object.entries(tadaridaUser).filter(
      ([key]) => !USER_DATA_EXCLUDED_FROM_PERSISTING.includes(key),
    ),
  );

  const shouldTransferSession =
    isAuthenticated || basketCount > 0 || wishlistCount > 0;

  const sessionData = {
    tadaridaUser: {
      key: USER_PERSIST_KEY,
      data: isAuthenticated ? mandatoryFieldsValues : null,
    },
    tadaridaUserOptional: {
      key: USER_PERSIST_OPTIONAL_KEY,
      data: isAuthenticated ? tadaridaOptionalUser : null,
    },
    tadaridaSession: {
      key: TADARIDA_SESSION_PERSIST_KEY,
      data: shouldTransferSession ? sessionState : null,
    },
  };

  return (
    <>
      {alternateLangUrl.map(alternateLocale => {
        const alternateUrl = isProxiedMobileDomain
          ? alternateLocale.alternateDomainUrl
          : alternateLocale.url;
        return (
          <ShareUserSession
            key={alternateUrl}
            alternateLangUrl={alternateUrl}
            sessionData={sessionData}
          />
        );
      })}
    </>
  );
};

export {SessionSharing};
